import { Menu } from "react-admin";
import { Typography } from "@mui/material";

const SectionLabel = ({ children }) => (
  <Typography
    variant="overline"
    sx={{
      px: 2,
      pt: 1.5,
      pb: 0.5,
      display: "block",
      opacity: 0.6,
      fontWeight: 700,
      fontSize: 11,
      letterSpacing: 0.5,
    }}
  >
    {children}
  </Typography>
);

export default function CustomMenu() {
  return (
    <Menu>
      <Menu.DashboardItem />

      <SectionLabel>Stagione</SectionLabel>
      <Menu.ResourceItem name="admin/seasons" />
      <Menu.ResourceItem name="admin/matches" />
      <Menu.ResourceItem name="admin/league-fixtures" />
      <Menu.ResourceItem name="admin/roster" />

      <SectionLabel>Anagrafica</SectionLabel>
      <Menu.ResourceItem name="admin/players" />
      <Menu.ResourceItem name="admin/opponents" />

      <SectionLabel>Contenuti</SectionLabel>
      <Menu.ResourceItem name="admin/news" />
      <Menu.ResourceItem name="admin/contacts" />
    </Menu>
  );
}
